import { DestinationStandardMapping } from "../types";

const googleAdsStandardMapping: DestinationStandardMapping = {
  wildcard: {
    propertiesArr: [],
  },
  items: [],
};

// TODO: Hit GoogleAds API and get customer's campaigns
export const getGoogleAdsStandardMapping = async () => {
  return googleAdsStandardMapping;
};
